
const digest = '7d2f65c558481e35e6a0f1e32bc1e3ca326f6438f36bbcdc5114ad11c0c97d51';
const classes = {"profile":"_profile_fb050_1","arrow":"_arrow_fb050_5","arrowUp":"_arrowUp_fb050_13","arrowDown":"_arrowDown_fb050_18"};
const css = `._profile_fb050_1 {
  position: relative;
  z-index: 1;
}
._profile_fb050_1 ._arrow_fb050_5 {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  position: absolute;
  right: 10px;
  cursor: pointer;
}
._profile_fb050_1 ._arrowUp_fb050_13 {
  background: #1452ac url(/dist/icons/v2/chevron-up.svg) no-repeat center center;
  background-size: 65%;
  bottom: -8px;
}
._profile_fb050_1 ._arrowDown_fb050_18 {
  background: #1452ac url(/dist/icons/v2/chevron-down.svg) no-repeat center center;
  background-size: 65%;
  bottom: -24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  